var _linearGradient;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -330.644,
    x2: -330.644,
    y1: 278.056,
    y2: 279.026,
    gradientTransform: "matrix(512 0 0 245.76 169545.875 -68194.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#f209fe",
    offset: 0.0019305019305019305
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#0bd1df",
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M393.38 378.88c-36.495 0-67.85-12.37-95.867-37.888-5.816-5.202-11.53-11.059-16.876-17.203-7.393-8.561-6.451-21.504 2.109-28.918 8.561-7.352 21.463-6.451 28.897 2.109 4.157 4.813 8.663 9.441 13.332 13.64 20.5 18.657 42.23 27.3 68.444 27.3 42.803 0 77.619-36.741 77.619-81.92s-34.836-81.92-77.66-81.92c-57.754 0-86.774 43.233-120.381 93.327-35.04 52.245-74.751 111.473-154.377 111.473C53.228 378.88 0 323.768 0 256s53.228-122.88 118.62-122.88c36.495 0 67.85 12.37 95.867 37.888 5.816 5.202 11.53 11.059 16.876 17.203 7.393 8.561 6.451 21.504-2.109 28.918-8.561 7.373-21.484 6.451-28.897-2.109-4.157-4.813-8.663-9.441-13.332-13.64-20.5-18.657-42.23-27.3-68.444-27.3-42.803 0-77.619 36.741-77.619 81.92s34.836 81.92 77.66 81.92c57.754 0 86.774-43.233 120.381-93.327 35.041-52.244 74.752-111.473 154.378-111.473C458.772 133.12 512 188.232 512 256s-53.228 122.88-118.62 122.88",
    style: {
      fill: "url(#a)"
    },
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.98e4d2eb24d66c54593afd9c90eacef1.svg";
export { ForwardRef as ReactComponent };